import React from 'react';
import {Layout, Spin} from 'antd';

const {Header, Content} = Layout;

class CkPage extends React.Component {

    constructor(props) {
        super(props);
    }


    componentDidMount() {

    }


    render() {
        return (
            <Layout style={{height:'calc(100vh - 48px)'}}>
                {
                    this.props.title ?  <Header className={"ck-page-header"}>
                        <div className="ck-page-header-title">
                            {this.props.title.props.children}
                        </div>
                        <div className="ck-page-header-nav">
                            {this.props.nav.props.children}
                        </div>
                        <div className="ck-page-header-actions">
                            {this.props.actions.props.children}
                        </div>
                    </Header>: null
                }

                <Content className="page-content" style={this.props.contentWrapStyle}>
                    <Spin spinning={this.props.loading}>
                        {this.props.content}
                    </Spin>
                    {this.props.contentWrap}
                </Content>
                {this.props.children}
            </Layout>
        );
    }
}


CkPage.contextTypes = {};

CkPage.defaultProps = {
    //页面导航上的左侧, 放面包屑组件
    title: <div></div>,
    //页面导航上的左侧,面包屑右侧的区域, 放一些过滤组件
    nav: <div></div>,
    //页面导航上的右侧, 放创建按钮
    actions: <div></div>,
    content: <div></div>,
    loading: false,
};

CkPage.propTypes = {}


export default CkPage;


// WEBPACK FOOTER //
// ./src/components/CkPage.jsx